import Model from './model';





export default Model.extend( {

    endpoint: 'types', responseAt: 'newstype',
    
    defaults() {
        return {
            name: '',
            cluster: null,
            group_id: null, 
            period_of_review_in_sec: undefined,
            deadline_type: 'AT_CREATE',
            default_type: 'f',
            departments: [],
            icon: 'default_icon.png',
            role_ids: null, __all_roles_available: undefined
        };
    },

    customParser(payload) {
        if (payload.period_of_review_in_sec)
            payload.period_of_review_in_sec = +payload.period_of_review_in_sec;

        return payload;
    },

    diff(another) {
        const isForAll = type => 
            type.get( 'role_ids' ) == null ||
            type.get( '__all_roles_available' );

        if (isForAll( this ) != isForAll( another ))
            return [{
                attrName: 'role_ids'
            }];

        return Model.prototype.diff.call( this, another )
            .filter( ({ attrName }) => attrName !== '__all_roles_available' )
            // isForAll() is the same, so -> ignore role_ids
            .filter( ({ attrName }) => 
                attrName !== 'role_ids' ||
                // take roles into account only for non-all types
                attrName === 'role_ids' && !isForAll( this ) )
    },
    
} );


// WEBPACK FOOTER //
// ./src/js/model/newstype.js